import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_ChiefComplaintReasonEncounter = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_ChiefComplaintReasonEncounter' className='file-pdf-document'>
            <div className='file-template'>

                
                <p className='w-750'><h2>Mental Status Exam</h2></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Neurologic</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeurologic_1' name='cbNeurologic_1' className='add-only' value='Alert' />
                            Alert
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeurologic_2' name='cbNeurologic_2' className='add-only' value='Drowsy' />
                            Drowsy
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeurologic_3' name='cbNeurologic_3' className='add-only' value='Waxing/Waning' />
                            Waxing/Waning
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeurologic_4' name='cbNeurologic_4' className='add-only' value='Somnolent' />
                            Somnolent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeurologic_5' name='cbNeurologic_5' className='add-only' value='Stuporous' />
                            Stuporous
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNeurologic_6' name='cbNeurologic_6' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtNeurologicOther' name='txtNeurologicOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Orientation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='Aao' />
                            AAO*4
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='Self' />
                            Self
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_3' name='cbOrientation_3' className='add-only' value='Time' />
                            Time
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_4' name='cbOrientation_4' className='add-only' value='Place' />
                            Place
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_5' name='cbOrientation_5' className='add-only' value='Situation' />
                            Situation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_6' name='cbOrientation_6' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtOrientationOther' name='txtOrientationOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='WellGroomed' />
                            Well-groomed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Disheveled' />
                            Disheveled
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='Malodorous' />
                            Malodorous
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_4' name='cbAppearance_4' className='add-only' value='PoorGrooming' />
                            Poor grooming
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAppearance_5' name='cbAppearance_5' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtAppearanceOther' name='txtAppearanceOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Psychomotor</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychomotor_1' name='cbPsychomotor_1' className='add-only' value='Relaxed' />
                            Relaxed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychomotor_2' name='cbPsychomotor_2' className='add-only' value='Passive' />
                            Passive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychomotor_3' name='cbPsychomotor_3' className='add-only' value='Restless' />
                            Restless
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychomotor_4' name='cbPsychomotor_4' className='add-only' value='Agitation' />
                            Agitation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychomotor_5' name='cbPsychomotor_5' className='add-only' value='Retardation' />
                            Retardation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychomotor_6' name='cbPsychomotor_6' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtPsychomotorOther' name='txtPsychomotorOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Memory</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMemory_1' name='cbMemory_1' className='add-only' value='Intact' />
                            Intact
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMemory_2' name='cbMemory_2' className='add-only' value='ImpairedShortTerm' />
                            Impaired Short-term
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMemory_3' name='cbMemory_3' className='add-only' value='ImpairedLongTerm' />
                            Impaired Long-term
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMemory_4' name='cbMemory_4' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtMemoryOther' name='txtMemoryOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Attention/Concentration</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConcentration_1' name='cbConcentration_1' className='add-only' value='Normal' />
                            Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConcentration_2' name='cbConcentration_2' className='add-only' value='AttentionLimited' />
                            Attention limited
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConcentration_3' name='cbConcentration_3' className='add-only' value='ConcentrationLimited' />
                            Concentration limited
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Euthymic' />
                            Euthymic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Angry' />
                            Angry
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Anxious' />
                            Anxious
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Depressed' />
                            Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Euphoric' />
                            Euphoric
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Hypomanic' />
                            Hypomanic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_7' name='cbMood_7' className='add-only' value='Irritable' />
                            Irritable
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMood_8' name='cbMood_8' className='add-only' value='Labile' />
                            Labile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMood_9' name='cbMood_9' className='add-only' value='Manic' />
                            Manic
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='MoodCongruent' />
                            Mood congruent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='MoodIncongruent' />
                            Mood incongruent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Inappropriate' />
                            Inappropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Blunt' />
                            Blunt
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Constricted' />
                            Constricted
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_6' name='cbAffect_6' className='add-only' value='Bright' />
                            Bright
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_7' name='cbAffect_7' className='add-only' value='Euphoric' />
                            Euphoric
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_8' name='cbAffect_8' className='add-only' value='Anxious' />
                            Anxious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAffect_9' name='cbAffect_9' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtAffectOther' name='txtAffectOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight/Judgement</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsight_1' name='cbInsight_1' className='add-only' value='InsightIntact' />
                            Insight intact
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsight_2' name='cbInsight_2' className='add-only' value='JudgementIntact' />
                            Judgement intact
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsight_3' name='cbInsight_3' className='add-only' value='InsightImpaired' />
                            Insight impaired
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsight_4' name='cbInsight_4' className='add-only' value='JudgementImpaired' />
                            Judgement impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Associations</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssociations_1' name='cbAssociations_1' className='add-only' value='Normal' />
                            Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssociations_2' name='cbAssociations_2' className='add-only' value='Disorganized' />
                            Disorganized
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssociations_3' name='cbAssociations_3' className='add-only' value='Loose' />
                            Loose
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssociations_4' name='cbAssociations_4' className='add-only' value='Circumstantial' />
                            Circumstantial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssociations_5' name='cbAssociations_5' className='add-only' value='Tangential' />
                            Tangential
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssociations_6' name='cbAssociations_6' className='add-only' value='GrosslyImpaired' />
                            Grossly Impaired
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Process </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtProcess_1' name='cbThoughtProcess_1' className='add-only' value='Linear' />
                            Linear
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtProcess_2' name='cbThoughtProcess_2' className='add-only' value='Incoherent' />
                            Incoherent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtProcess_3' name='cbThoughtProcess_3' className='add-only' value='Illogical' />
                            Illogical
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtProcess_4' name='cbThoughtProcess_4' className='add-only' value='Concrete' />
                            Concrete
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtProcess_5' name='cbThoughtProcesst_5' className='add-only' value='Rapid' />
                            Rapid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtProcess_6' name='cbThoughtProcess_6' className='add-only' value='FlightIdeas' />
                            Flight of ideas
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtProcess_7' name='cbThoughtProcesst_7' className='add-only' value='PovertyThought' />
                            Poverty of thought
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughtProcess_8' name='cbThoughtProcess_8' className='add-only' value='UnableFollowSimpleCommands' />
                            Unable to follow simple commands
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughtProcess_9' name='cbThoughtProcess_9' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtThoughtProcessOther' name='txtThoughtProcessOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Content </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_1' name='cbThoughtContent_1' className='add-only' value='Realistic' />
                            Realistic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_2' name='cbThoughtContent_2' className='add-only' value='OrganizedLinear' />
                            Organized/linear
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_3' name='cbThoughtContent_3' className='add-only' value='Dissociation' />
                            Dissociation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_4' name='cbThoughtContent_4' className='add-only' value='Preoccupied' />
                            Preoccupied
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_5' name='cbThoughtContent_5' className='add-only' value='Ruminating' />
                            Ruminating
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_6' name='cbThoughtContent_6' className='add-only' value='Delusional' />
                            Delusional
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_7' name='cbThoughtContent_7' className='add-only' value='Grandiosity' />
                            Grandiosity
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_8' name='cbThoughtContent_8' className='add-only' value='Religious' />
                            Religious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_9' name='cbThoughtContent_9' className='add-only' value='Obsessive' />
                            Obsessive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_10' name='cbThoughtContent_10' className='add-only' value='Phobic' />
                            Phobic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_11' name='cbThoughtContent_11' className='add-only' value='Paranoid' />
                            Paranoid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtContent_12' name='cbThoughtContent_12' className='add-only' value='Persecutory' />
                            Persecutory
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughtContent_13' name='cbThoughtContent_13' className='add-only' value='IdeasReference' />
                            Ideas of Reference
                        </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Language</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLanguage_1' name='cbLanguage_1' className='add-only' value='Normal' />
                            Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLanguage_2' name='cbLanguage_2' className='add-only' value='Simple' />
                            Simple
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLanguage_3' name='cbLanguage_3' className='add-only' value='Coarse' />
                            Coarse
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLanguage_4' name='cbLanguage_4' className='add-only' value='Articulate' />
                            Articulate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLanguage_5' name='cbLanguage_5' className='add-only' value='Impoverished' />
                            Impoverished
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLanguage_6' name='cbLanguage_6' className='add-only' value='Incoherent' />
                            Incoherent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLanguage_7' name='cbLanguage_7' className='add-only' value='Aphasic' />
                            Aphasic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLanguage_8' name='cbLanguage_8' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtLanguageOther' name='txtLanguageOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Fund of Knowledge</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFundKnowledge_1' name='cbFundKnowledge_1' className='add-only' value='Normal' />
                            Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFundKnowledge_2' name='cbFundKnowledge_2' className='add-only' value='Limited' />
                            Limited
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFundKnowledge_3' name='cbFundKnowledge_3' className='add-only' value='Extensive' />
                            Extensive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFundKnowledge_4' name='cbFundKnowledge_4' className='add-only' value='Impaired' />
                            Impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFundKnowledge_5' name='cbFundKnowledge_5' className='add-only' value='Other' />
                            Other: &nbsp;
                            <input type='text' id='txtFundKnowledgeOther' name='txtFundKnowledgeOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Normal' />
                            Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Slowed' />
                            Slowed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Rapid' />
                            Rapid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Pressured' />
                            Pressured
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Loud' />
                            Loud
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='Quiet' />
                            Quiet
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='Dysarthric' />
                            Dysarthric
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='Slurred' />
                            Slurred
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSpeech_9' name='cbSpeech_9' className='add-only' value='Incoherent' />
                            Incoherent
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Ideation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation_1' name='cbIdeation_1' className='add-only' value='Suicidal' />
                            Suicidal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation_2' name='cbIdeation_2' className='add-only' value='Homicidal' />
                            Homicidal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation_3' name='cbIdeation_3' className='add-only' value='NoneEvident' />
                            None Evident
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Describe: &nbsp;
                            <input type='text' id='txtIdeationDescribe' name='txtIdeationDescribe' className='add-only w-450 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Appraisal of treatment progress and Ongoing treatment plan:</span>
                    <textarea id='txtTreatmentProgress' name='txtTreatmentProgress' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Signs and Symptoms</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSignsSymptoms_1' name='cbSignsSymptoms' className='add-only' value='Improving' />
                            Improving
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSignsSymptoms_2' name='cbSignsSymptoms' className='add-only' value='MinimalResponse' />
                            Minimal Response
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSignsSymptoms_3' name='cbSignsSymptoms' className='add-only' value='ClinicalDecline' />
                            Clinical Decline
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSignsSymptoms_4' name='cbSignsSymptoms' className='add-only' value='Atbaseline' />
                            At baseline
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Alteration to medication management plans</span>

                    <b>Medications Changes:</b> &nbsp;
                    <input type='radio' id='rbMedicationsChanges_Y' name='rbMedicationsChanges' className='add-only' value='N' /> No &nbsp;
                    <input type='radio' id='rbMedicationsChanges_N' name='rbMedicationsChanges' className='add-only' value='Y' /> Yes (Why)<input type='text' id='txtMedicationsChangesWhy' name='txtMedicationsChangesWhy' className='add-only' />
                </p>

                <p className='w-750'>
                    <b>The potential Side Effects, Benefits, and alternatives to new medications discussed with client/Caregiver verbalizing understanding and contest:</b> &nbsp;
                    <br />
                    <input type='radio' id='rbBenefits_Na' name='rbBenefits' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='radio' id='rbBenefits_Y' name='rbBenefits' className='add-only' value='N' /> No &nbsp;
                    <input type='radio' id='rbBenefits_N' name='rbBenefits' className='add-only' value='Y' /> Yes (Medication)<input type='text' id='txtBenefitsMedication' name='txtBenefitsMedication' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-190'><b>Medication</b></td>
                        <td className='w-70'><b>Dosage</b></td>
                        <td className='w-120'><b>Directions</b></td>
                        <td className='w-180'><b>Date start/Last Use</b></td>
                        <td className='w-170'><b>Complaint</b></td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_1' name='txtDirections_1' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_1' name='txtDateStart_1' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_1' name='txtComplaint_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_2' name='txtDirections_2' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_2' name='txtDateStart_2' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_2' name='txtComplaint_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_3' name='txtDirections_3' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_3' name='txtDateStart_3' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_3' name='txtComplaint_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_4' name='txtDirections_4' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_4' name='txtDateStart_4' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_4' name='txtComplaint_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_5' name='txtDirections_5' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_5' name='txtDateStart_5' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_5' name='txtComplaint_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_6' name='txtMedication_6' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_6' name='txtDosage_6' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_6' name='txtDirections_6' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_6' name='txtDateStart_6' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_6' name='txtComplaint_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_7' name='txtMedication_7' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_7' name='txtDosage_7' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_7' name='txtDirections_7' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_7' name='txtDateStart_7' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_7' name='txtComplaint_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_8' name='txtMedication_8' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_8' name='txtDosage_8' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_8' name='txtDirections_8' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_8' name='txtDateStart_8' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_8' name='txtComplaint_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_9' name='txtMedication_9' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_9' name='txtDosage_9' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_9' name='txtDirections_9' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_9' name='txtDateStart_9' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_9' name='txtComplaint_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-190'>
                            <input type='text' id='txtMedication_10' name='txtMedication_10' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type='text' id='txtDosage_10' name='txtDosage_10' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtDirections_10' name='txtDirections_10' className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type='date' id='txtDateStart_10' name='txtDateStart_10' className='add-only' />

                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtComplaint_10' name='txtComplaint_10' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Clinicial Summary (Optional)</span>
                    <textarea id='txtClinicialSummary' name='txtClinicialSummary' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Diagnosis</span>
                    <textarea id='txtDiagnosis' name='txtDiagnosis' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











